import { useContext } from 'react'

import { Heading } from '@hhgtech/hhg-components'
import { PremiumBadge } from 'components/atoms/premiumBadge'
import { StructuredSources } from 'components/molecules'
import { useGetIsMobile, useScreenSize } from 'hooks'
import innertext from 'innertext'
import {
  Author,
  ArticleExpert,
  ReviewedApi,
  TableOfContentItem,
} from 'interfaces/types'
import { AppContext } from 'state/appContext'

import { StyledJumpingLink, StyledOpeningOfArticle } from './index.styled'

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  header: string
  author: Author
  expert?: ArticleExpert
  reviewer?: Author
  articleReviewed?: ReviewedApi
  updatedAt: string
  createdAt?: string
  tableOfContents?: Array<TableOfContentItem>
  jumpingLink?: Array<string>
  isPremium?: boolean
}

const OpeningOfArticle = ({
  className,
  size = 'md',
  header,
  tableOfContents,
  jumpingLink,
  isPremium,
}: Props) => {
  const { state } = useContext(AppContext)
  const { isMobileSsr } = state || {}

  const { isMobile: isMobileCsr } = useScreenSize()
  const isMobile = useGetIsMobile(isMobileSsr, isMobileCsr)
  return (
    <StyledOpeningOfArticle className={className}>
      {isPremium && <PremiumBadge className="premium-badge" />}
      <Heading tag="h1" className="article-header">
        {innertext(header)}
      </Heading>
      {isMobile && tableOfContents && tableOfContents?.length >= 1 && (
        <StructuredSources
          size={size}
          sources={tableOfContents}
          className="article-table-content"
        />
      )}
      {jumpingLink && (
        <StyledJumpingLink>
          {jumpingLink.map((element, index) => (
            <li key={index}>
              <span
                dangerouslySetInnerHTML={{
                  __html: element,
                }}
              />
            </li>
          ))}
        </StyledJumpingLink>
      )}
    </StyledOpeningOfArticle>
  )
}

export { OpeningOfArticle }
